import React from "react";
const getFillColor = (color: string) => {
  return color === "currentColor" ? `` : `var(--color-${color})`;
};
const SvgVideoGalleryIcon = ({
  title,
  theme = null,
  titleId = "",
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 64 64"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g fill="currentColor">
      <path
        d="M4 48V18a4 4 0 0 0-4 4v32a4 4 0 0 0 4 4h44a4 4 0 0 0 4-4H10a6.006 6.006 0 0 1-6-6Z"
        data-color="color-2"
      />
      <path
        d="M10 42V12a4 4 0 0 0-4 4v32a4 4 0 0 0 4 4h44a4 4 0 0 0 4-4H16a6.006 6.006 0 0 1-6-6Z"
        data-color="color-2"
      />
      <path d="M60 6H16a4 4 0 0 0-4 4v32a4 4 0 0 0 4 4h44a4 4 0 0 0 4-4V10a4 4 0 0 0-4-4ZM46.524 26.852l-13 8A1 1 0 0 1 32 34V18a1 1 0 0 1 1.524-.852l13 8a1 1 0 0 1 0 1.7Z" />
    </g>
  </svg>
);
export interface Props {
  color?: string;
  width?: string;
  height?: string;
  title: string;
  titleId?: string;
  theme?: any;
  fill?: string;
}
const SvgVideoGalleryStyle = ({
  color = "currentColor",
  title,
  fill,
  ...props
}: Props) => (
  <SvgVideoGalleryIcon
    color={getFillColor(color)}
    className={color === "currentColor" ? "icon-current-color" : ""}
    {...(color !== "currentColor"
      ? { style: { color: getFillColor(color), fill: getFillColor(color) } }
      : null)}
    fill={fill ?? getFillColor(color)}
    title={title}
    {...props}
  />
);
export const VideoGalleryIcon: any = SvgVideoGalleryStyle;
export default VideoGalleryIcon;
